import Entity from '@/models/entities/Entity';
import { FontGroup } from '@/models/entities/FontGroup';

export class Font implements Entity {
  public id: number = 0;
  public name: string = '';
  public fontFamily: string = '';
  public ascent: number = 0;
  public boldAllowed: boolean = false;
  public italicAllowed: boolean = false;
  public vector: string = '';
  public fontGroups: FontGroup[] = [];

  constructor(initData: Partial<Font>) {
    Object.assign(this, initData);
  }
}
